import { Injectable } from '@angular/core';
import { from, Subject } from 'rxjs';
import { filter, flatMap, take } from 'rxjs/operators';
import { KeycloakInit } from 'src/app/keycloak/keycloak-init';
import { UserSessionStatus } from 'src/app/reports/model/user-session-status';
import { UserSettingsService } from 'src/app/settings/service/user-settings.service';
import { WEBSOCKET_TOPIC_USERS_LOGIN_STATE } from '../const';
import { UserGroup } from '../model/user-profile';
import { UserProfileService } from './user-profile.service';
import { WebsocketClient } from './websocket-client.service';

@Injectable({
  providedIn: 'root'
})
export class UserTokenService {

  private userTokenChangeSubscription = new Subject<UserSessionStatus>();
  userTokenChange$ = this.userTokenChangeSubscription.asObservable();


  private reloadGroupsSubscription = new Subject<UserGroup[]>();
  reloadGroups$ = this.reloadGroupsSubscription.asObservable();

  constructor(private websocketClient: WebsocketClient, private userProfile: UserProfileService
    , private keycloak: KeycloakInit, private userSettingsService: UserSettingsService) { }

  init(): void {
    this.websocketClient.websocketConnectionConnected$
      .pipe(filter(connected => connected))
      .subscribe(() => this.connectToUserTokenWebsocket());
  }

  private connectToUserTokenWebsocket(): void {
    this.userProfile.updateUserProfile$
      .pipe(take(1))
      .subscribe(profile => {
        this.websocketClient.subscribe(WEBSOCKET_TOPIC_USERS_LOGIN_STATE + '/' + profile.username)
          .subscribe(response => this.onNewSessionStatus(response.toString()));
      });
  }

  private onNewSessionStatus(userSessionStatus: string): void {
    if (UserSessionStatus[userSessionStatus] == UserSessionStatus.REVOKED) {
      this.userProfile.logout();
    } else if (UserSessionStatus[userSessionStatus] == UserSessionStatus.RIGHTS_CHANGED) {
      const userProfile = this.userProfile.getUserProfile();
      const oldGroups = userProfile.groups;
      userProfile.groups = null;
      this.userSettingsService.clearSettings();
      from(this.keycloak.refresh())
        .pipe(flatMap(() => this.userSettingsService.loadSettings()))
        .subscribe(() => {
          this.reloadGroupsSubscription.next(oldGroups);
        });
    }
  }
}
